export const dates = (startDate, endDate, focusedInput) => {
  if (focusedInput === 'startDate') {
    if (startDate && endDate) {
      return {startDate, endDate: null, focusedInput: 'endDate'};
    }
    return {startDate, endDate, focusedInput: 'endDate'};
  }

  if (focusedInput === 'endDate') {
    if (endDate && startDate && endDate.isBefore(startDate)) {
      return {startDate: endDate, endDate: null, focusedInput: 'endDate'};
    }
    return {startDate, endDate, focusedInput: 'startDate'};
  }

  return {startDate, endDate, focusedInput};
};
